export class CreateConnectorInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "connectorType",
            "baseName": "connectorType",
            "type": "ConnectorType",
            "format": ""
        },
        {
            "name": "awsAccountProperties",
            "baseName": "awsAccountProperties",
            "type": "AwsAccountConnectorPropertiesInput",
            "format": ""
        },
        {
            "name": "gcpProjectProperties",
            "baseName": "gcpProjectProperties",
            "type": "GcpProjectConnectorPropertiesInput",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateConnectorInput.attributeTypeMap;
    }
    constructor() {
    }
}
